import {ResearchLitElement, html, css, unsafeHTML, ifDefined} from '@core/research-lit-element';

import '@bog-design-system/bd-modal';
import '@bog-design-system/bd-list-item';
import '@bog-design-system/bd-font';
import '@bog-design-system/bd-icon';
import '@bog-design-system/bd-button';
import '@bog-design-system/bd-standard-button';
import '@bog-design-system/bd-scroll';
import '@bog-design-system/bd-space-description';

class ResearchInfoModal extends ResearchLitElement {
    static get is() {
        return 'research-info-modal';
    }
    static get styles() {
        return css`
            :host {
                display: flex;
                flex-direction: column;
                justify-content: center;
            }

            .modal-header-title {
                color: var(--color-invert-component-tr-20);
            }

            .wrapper {
                display: flex;
                flex-direction: column;
                align-items: center;
                padding: var(--space-12) var(--space-32) var(--space-24);
            }

            .item {
                margin-top: var(--space-24);
                width: 707px;
            }

            .header {
                margin-bottom: var(--space-8);
                width: 100%;
                display: flex;
                gap: var(--space-12);
                align-items: center;
            }

            .header-title {
                color: var(--color-invert-component-tr-30);
            }

            .content {
                width: 100%;
                border-radius: var(--border-radius-31);
            }

            bd-icon {
                color: var(--color-success-solid-10);
            }

            bd-list-item {
                --padding-left: calc(var(--space-24) + var(--space-4));
                --li-bg: var(--color-invert-background-solid-20);
                --li-min-height: var(--space-64);
            }

            bd-list-item:first-child {
                border-top-left-radius: var(--border-radius-31);
                border-top-right-radius: var(--border-radius-31);
                padding-top: var(--space-8);
            }

            bd-list-item:last-child {
                --border-color: transparent;
                border-bottom-left-radius: var(--border-radius-31);
                border-bottom-right-radius: var(--border-radius-31);
                padding-bottom: var(--space-8);
            }

            .list-item {
                display: flex;
                flex-direction: column;
                gap: var(--space-2);
                padding: var(--space-8) 0;
            }

            .list-item-title {
                color: var(--color-invert-component-tr-40);
            }

            .list-item-description {
                color: var(--color-invert-component-tr-20);
            }

            .list-item-additional-text {
                color: var(--color-invert-component-tr-40);
            }

            .footer {
                display: flex;
                justify-content: flex-end;
                gap: var(--space-8);
            }
          
            @media (max-width: 768px) {
                .wrapper {
                    padding-left: var(--space-24);
                    padding-right: var(--space-24);
                }

                .item {
                    width: 100%;
                }
            }
            @media (max-width: 600px) {
                .footer-button {
                    width: 100%;
                }
            }
        `;
    }
    render() {
        return html`
            <bd-modal-header class="modal-header">
                <bd-font type="title" slot="title" class="modal-header-title">
                    <span> ${this.data?.modalTitle} </span>
                </bd-font>
                <bd-button type="secondary" icon="bd:close" mini icon-only slot="close" dropdownicon="bd:chevron_down">
                </bd-button>
            </bd-modal-header>
            <bd-scroll>
                <div class="wrapper">
                    <bd-font type="body1" class="description">
                        <span
                            >${this.data?.htmlText ?
                                unsafeHTML(this.data.htmlText) :
                                this.data.text ?
                                this.data.text :
                                ''}</span
                        >
                    </bd-font>
                </div>
            </bd-scroll>
            <bd-modal-footer class="footer">
                ${this.data?.secondaryBtnLabel ?
                    html`
                          <bd-standard-button
                              type="text-primary"
                              class="secondary-button"
                              size="small"
                              @click="${this._closeModal}"
                          >
                              ${this.data.secondaryBtnLabel}
                          </bd-standard-button>
                      ` :
                    ''}
                <bd-standard-button
                    type="primary"
                    class="primary-button"
                    size="small"
                    href="${ifDefined(this.registrationUrl?.link)}"
                    target="${ifDefined(this.registrationUrl?.target)}"
                >
                    ${this.data?.primaryBtnLabel}
                </bd-standard-button>
            </bd-modal-footer>
        `;
    }
    static get properties() {
        return {
            data: {
                type: Object,
            },
            registrationUrl: {
                type: Object,
            },
        };
    }

    constructor() {
        super();
    }
    connectedCallback() {
        super.connectedCallback();
    }

    _closeModal() {
        this.dispatchEvent(
            new CustomEvent('close-modal', {
                bubbles: true,
                composed: true,
            })
        );
    }
}
window.customElements.define(ResearchInfoModal.is, ResearchInfoModal);
